import React from 'react';
import { connect } from 'react-redux';
import MultiCurrencyDropdown from './multi-currency-dropdown';
import actions from '../../state/actions/multi-currency';

class MultiCurrencySelector extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { dispatch, isCurrencyChosenByUser } = this.props;
        if (isCurrencyChosenByUser) {
            return null;
        }
        const cross = (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12">
                <g fill="#6e7580" fillRule="evenodd">
                    <path d="M.5 2.621L2.622.5l9.192 9.192-2.121 2.122z" />
                    <path d="M9.692.5l2.122 2.122-9.193 9.192L.5 9.693z" />
                </g>
            </svg>
        );

        const close = () => {
            dispatch(actions.setCurrencySelectedByUser());
        };
        return (
            <div className="bp multi-currency-selector noselect">
                <button
                    className="btn btn-link multi-currency-selector-close-btn"
                    onClick={close}>
                    {cross}
                </button>
                <div className="multi-currency-selector-left-side">
                    We think you use
                </div>
                <div className="multi-currency-selector-right-side">
                    <button className="btn btn-primary btn-sm" onClick={close}>
                        OK
                    </button>
                </div>
                <MultiCurrencyDropdown id="above-top-menu" />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        selectedCurrency: state.multiCurrency.preferredCurrency,
        isCurrencyChosenByUser: state.multiCurrency.isCurrencyChosenByUser,
        ...ownProps
    };
};

export default connect(mapStateToProps)(MultiCurrencySelector);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/multi-currency/multi-currency-selector.jsx